import { createContext, useContext } from 'react';

const AnalyticsContext = createContext<any>(undefined);

export const useAnalyticsContext = () => useContext(AnalyticsContext);
export default AnalyticsContext;
